import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography
} from "@mui/material/";
import { useSelector } from "react-redux";
import { strings } from "../../common/i18n";
import MenuOptions from "../components/common/MenuOptions";
import MatReactTable from "../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";

/**
 * Users Table Component
 */

export default () => {
    const { item } = useSelector((state) => state.accounts);
    const {
        columns,
        data,
        deleteDialog,
        setDeleteDialog,
        handleDeleteDialogClose,
        handleDeleteDialogOpen,
        handleRemoveUser,
        currentSelectedRow,
        rowActions,
        error,
        onCsvMap,
        onCsvUpload,
        onDataItemAdd,
        onDataItemClear,
        onDataItemSet,
        onDataSave,
        optionOpen,
        onMenuOpen,
        onMenuClose,
        toolBarComponents
    } = useColumnsRows();

    return (
        <>
            <MatReactTable
                persistKey="manageUsers"
                columns={columns}
                data={data}
                loading={false}
                rowActions={rowActions}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noAssets")}
            />
            <Dialog
                open={deleteDialog}
                onClose={handleDeleteDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {strings("removeUser")}
                </DialogTitle>
                <DialogContent dividers>
                    <DialogContentText id="alert-dialog-description">
                        <Typography variant="subtitle2" gutterBottom>
                            {strings("messages.removeUserConfirmation")}
                            {currentSelectedRow && (
                                <Typography
                                    component="span"
                                    sx={{ fontWeight: "bold" }}
                                    variant="body2"
                                >
                                    {currentSelectedRow.displayName} ?
                                </Typography>
                            )}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions dividers>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDeleteDialogClose}
                    >
                        {strings("cancel")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="success"
                        onClick={handleRemoveUser}
                        autoFocus
                    >
                        {strings("remove")}
                    </Button>
                </DialogActions>
            </Dialog>
            <MenuOptions
                columns={columns}
                data={data}
                header={strings("users")}
                optionOpen={optionOpen}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                error={error}
                csvFileName={strings("users")}
                onCsvMap={onCsvMap}
                onCsvUpload={onCsvUpload}
                onDataItemAdd={onDataItemAdd}
                onDataItemClear={onDataItemClear}
                onDataItemSet={onDataItemSet}
                onDataSave={onDataSave}
                dataItem={item}
                // FormComponent={LocationForm}
            />
        </>
    );
};
